import { useEffect, useRef } from "react";
import type { ReactNode } from "react";

type ConfirmDialogProps = {
  open: boolean;
  title: string;
  children: ReactNode;
  confirmLabel: string;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ConfirmDialog({ open, title, children, confirmLabel, busy = false, onCancel, onConfirm }: ConfirmDialogProps) {
  const panel = useRef<HTMLDivElement>(null);
  const cancel = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    const previous = document.activeElement;
    cancel.current?.focus();
    return () => {
      if (previous instanceof HTMLElement && previous.isConnected) previous.focus();
    };
  }, [open]);
  if (!open) return null;
  return (
    <div className="anl-dialog-layer">
      <div
        ref={panel}
        role="dialog"
        aria-modal="true"
        aria-labelledby="anl-confirm-title"
        className="anl-dialog"
        onKeyDown={(event) => {
          if (event.key === "Escape" && !busy) onCancel();
          if (event.key !== "Tab") return;
          const controls = panel.current?.querySelectorAll<HTMLElement>("button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), a[href]");
          const first = controls?.item(0);
          const last = controls?.item((controls?.length ?? 1) - 1);
          if (event.shiftKey && document.activeElement === first && last) { event.preventDefault(); last.focus(); }
          if (!event.shiftKey && document.activeElement === last && first) { event.preventDefault(); first.focus(); }
        }}
      >
        <h2 id="anl-confirm-title">{title}</h2>
        <div className="anl-dialog-content">{children}</div>
        <div className="anl-actions">
          <button ref={cancel} type="button" className="anl-button" disabled={busy} onClick={onCancel}>Vazgeç</button>
          <button type="button" className="anl-button is-primary" disabled={busy} onClick={onConfirm}>{busy ? "Kaydediliyor…" : confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
